
export const currentSurveyLink = 'https://form.jotform.com/223267663742865'
export const surveyTitle = 'Kia Ora!'
export const surveyStartDate = new Date('2022-11-30')
export const surveyEndDate = new Date('2022-12-16 18:01:00') //set end date to be real end date +1 minute so we wont have to worry about time